import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const UserMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);

  const [addUserMo, setAddUserMo] = useState('');
  const [addUserName, setAddUserName] = useState('');
  const [addUserRole, setAddUserRole] = useState('');

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "User Master";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            setModalVisible(false);
            setAddModalVisible(false);
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
      const fetchUserList = async () => { 
          try {
            const response = await fetch(`${host_url}/user_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                suId : '',
                suName: '',
                suMo: '',
                suRole: '',
                suStatus: '',
              }),
            });
            const data = await response.json();
            setUsers(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchUserList(); 
    }, [host_url, store]);

    

    const [userMoFilter, setUserMoFilter] = useState('');
    const [userNameFilter, setUserNameFilter] = useState('');
    const [userRoleFilter, setUserRoleFilter] = useState('');
    const [userStatusFilter, setUserStatusFilter] = useState('');

    const filteredUsers = users.filter(users =>
      String(users.suMo).toLowerCase().includes(userMoFilter.toLowerCase()) &&
      users.suName.toLowerCase().includes(userNameFilter.toLowerCase()) &&
      users.suRole.toLowerCase().includes(userRoleFilter.toLowerCase()) &&
      users.suStatus.toLowerCase().includes(userStatusFilter.toLowerCase())
    );

    const totalCount = filteredUsers.length;
   
    const handleUserDetail = (user) => {
      setModalVisible(true);
      setSelectedUser(user);
    };

    // Functions for handling the different actions
    const handleAddUser = async () => {
      setAddModalVisible(false);
      try {
        const response = await fetch(`${host_url}/user_list`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
            'userid': localStorage.getItem('userid'),
          },
          body: JSON.stringify({
            type: 'insert',
            store: store,
            suId : '',
            suName: addUserName,
            suMo: addUserMo,
            suRole: addUserRole,
            suStatus: 'Y',
          }),
        });

        if (response.status === 401) {
          localStorage.clear();
          alert('Your account has been disabled.');
          window.location.href = "/";
          return;
        }
      
        const data = await response.json();
        setUsers(data);
        setAddUserMo('');
        setAddUserName('');
        setAddUserRole('');
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateUser = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/user_list`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'update',
            store: store,
            suId : selectedUser.suId,
            suName: selectedUser.suName,
            suMo: selectedUser.suMo,
            suRole: selectedUser.suRole,
            suStatus: selectedUser.suStatus,
          }),
        });
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Users Master</b>
              <div onClick={() => setAddModalVisible(true)}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th>Mobile</th>
                <th>Name</th>
                <th>Role</th>
                <th>Active</th>
              </tr>
              <tr>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={userMoFilter}
                    onChange={(e) => setUserMoFilter(e.target.value)}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={userNameFilter}
                    onChange={(e) => setUserNameFilter(e.target.value)}
                  />
                </th>
                <th>
                  <select
                    className="search-input"
                    value={userRoleFilter}
                    onChange={(e) => setUserRoleFilter(e.target.value)}
                  >
                    <option value="">All Roles</option>
                    <option value="Admin">Admin</option>
                    <option value="Manager">Manager</option>
                    <option value="Marketing">Marketing</option>
                    <option value="Packers">Packers</option>
                    {/* Add more roles as needed */}
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={userStatusFilter}
                    onChange={(e) => setUserStatusFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </select>
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredUsers.map((row) => {
                  return (
                    <tr key={row.suId} style={{ lineHeight: '10px' }} onClick={() => handleUserDetail(row)}>
                      <td ><span style={{ paddingLeft: '10px' }}>{row.suMo}</span></td>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.suName}</span></td>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.suRole}</span></td>
                      <td>
                        <span style={{display: 'flex', paddingLeft: '10px'}}>
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: row.suStatus === 'N' ? '#ff0000' : '#00962d', marginRight: '5px'}}></span>
                          <span>{row.suStatus === 'N' ? 'Inactive' : 'Active'}</span>
                        </span>
                      </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='3'><span style={{ paddingLeft: '10px' }}>Total</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for USer Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >User Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Mobile No.</td>
                        <td><input type="text" maxLength="10" value={selectedUser.suMo} onChange={(e) => setSelectedUser({ ...selectedUser, suMo: e.target.value.replace(/[^0-9]/g, '').slice(0, 10) })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Name</td>
                        <td><input type="text" value={selectedUser.suName} onChange={(e) => setSelectedUser({ ...selectedUser, suName: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Role</td>
                        <td><select
                              value={selectedUser.suRole}
                              onChange={(e) => setSelectedUser({ ...selectedUser, suRole: e.target.value })}
                            >
                              <option value="Admin">Admin</option>
                              <option value="Manager">Manager</option>
                              <option value="Marketing">Marketing</option>
                              <option value="Packers">Packers</option>
                            </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Status</td>
                        <td><select
                              value={selectedUser.suStatus}
                              onChange={(e) => setSelectedUser({ ...selectedUser, suStatus: e.target.value })}
                            >
                              <option value="Y">Active</option>
                              <option value="N">Inactive</option>
                            </select>
                        </td>                      
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateUser}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>               
              </ModalBody>
            </Modal>

          {/* Modal for Add New User */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New User</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Mobile No.</td>
                        <td><input type="text" maxLength="10" value={addUserMo} onChange={(e) => setAddUserMo(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Name</td>
                        <td><input type="text" value={addUserName} onChange={(e) => setAddUserName(e.target.value)} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Role</td>
                        <td><select
                              value={addUserRole}
                              onChange={(e) => setAddUserRole(e.target.value)}
                            >
                              <option value="Admin">Admin</option>
                              <option value="Manager">Manager</option>
                              <option value="Marketing">Marketing</option>
                              <option value="Packers">Packers</option>
                            </select>
                        </td>                      
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddUser}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default UserMaster;
